module.exports = __webpack_public_path__ + "img/cold.be5030ca.webp";